import React, { useEffect } from 'react'
import { Modal } from '../../CommonComponents/Modal/Modal.tsx'
import { useModalStore } from './ModalStore.ts'

const DataModal: React.FC = () => {
    const data = useModalStore(x => x.child)
    const reset = useModalStore(x => x.reset)

    return (
        <Modal onClose={reset}>
            {data}
        </Modal>
    )
}

export const ModalLayer: React.FC<React.PropsWithChildren> = ({ children }) => {
    const showModal = useModalStore(x => x.showModal)
    useEffect(() => {
        showModal && window.scroll(0, 0)
    }, [showModal])
    return (
        <>
            {children}
            {showModal && <DataModal />}
        </>
    )
}
